var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftBar" },
    [
      _c("v-drawer", { attrs: { direction: "left", width: "26%" } }, [
        _c(
          "div",
          { staticClass: "animated fadeInLeftBig dx" },
          [
            _c(
              "bar-card",
              { staticClass: "lefts", attrs: { bg: "border-new" } },
              [
                _c("g-title", { attrs: { bg: "fpgh" } }, [
                  _vm._v("农村人居环境整治"),
                ]),
                _c("div", { staticClass: "panelContent" }, [_c("left-bot")], 1),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }